import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AttiFormComponent } from 'src/app/common/form/atti-form.component';
import { Atto } from 'src/app/common/models/atto';
import { OperationsService } from 'src/app/core/services/operations.service';
import { CreazionePraticaTipologicheService } from '../../../services/creazione-pratica-tipologiche.service';
import { HelpersService } from 'src/app/core/services/helpers.service';

@Component({
  selector: 'app-step-atti-form',
  templateUrl: '../../../../../../common/form/atti-form.component.html',
})
export class StepAttiFormComponent extends AttiFormComponent implements OnInit, OnChanges {
  @Output() sendAttoEvent: EventEmitter<Atto> = new EventEmitter<Atto>();
  @Output() showListEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() annullaModificheEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() pulisciCampiEvent: EventEmitter<void> = new EventEmitter<void>();
  @Input() attoToEdit: Atto;
  @Input() attoAssociato: Atto;

  isReset: boolean;


  constructor(@Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm, private tipologicheService: CreazionePraticaTipologicheService, @Inject(HelpersService) helpers: HelpersService) {
    super(operationService, campiForm, helpers);

    this.isGestioneDocumenti = true;
  }

  ngOnInit() {
    this.setTitle("Nuovo atto");
    this.isInserimento(true);
    this.isReset = false;
    this.inizializza();
    if (this.attoToEdit !== undefined) {
      this.setTitle("Modifica atto");
      this.isInserimento(false);
    }
  }

  ngOnChanges() {
    if (this.attoToEdit !== undefined && !this.attoAssociato) {
      this.setTitle("Modifica atto");
      this.isInserimento(false);
      this.inizializza();
    }
    else {
      //se riceve un atto associato lo considera un nuovo atto
      this.ngOnInit();
    }
  }


  getAtto(): Atto {
    if (this.attoToEdit === undefined && this.attoAssociato === undefined) {
      //Aggiungi atto
      return new Atto();
    }
    // (this.attoToEdit !== undefined || this.attoAssociato !== undefined) &&
    else if (this.isReset) {
      //Modifica atto e  premo reset
      this.attoToEdit = undefined;
      this.attoAssociato = undefined;
      this.isReset = false;
      return new Atto();
    }
    else if (this.attoToEdit !== undefined && !this.isReset) {
      //Modifica atto
      // this.isReset = true;
      return this.attoToEdit;
    }
    else {
      // this.isReset = true;
      return this.attoAssociato;
    }
  }


  onAnnullaModifiche() {
    this.attoToEdit = undefined;
    this.isReset = false;
    this.ngOnInit();
    this.showListEvent.emit();
    this.annullaModificheEvent.emit();
  }

  onPulisciCampi() {
    this.isReset = true;
    this.attoAssociato = undefined;
    this.createForm();
    this.pulisciCampiEvent.emit();
  }

  getRequest(request: Atto) {
    this.attoToEdit = undefined;
    this.isReset = false;
    this.sendAttoEvent.emit(request);
    this.request = new Atto();
    this.attiForm.reset();
    this.attoAssociato = undefined;

  }

  getFascicolo(): any {
    return null;
  }

  populateSelect() {
    this.tipologicheService.getTipiAtto().subscribe(response => {this.tipiAttoOptions = response});
    this.tipologicheService.getTipiProvenienza().subscribe(response => this.tipiProvenienzaOptions = response);
  }

  inizializza() {
    this.createForm();
  }

}
